import stateClasses from "../data/stateClasses";

export default class YouTubeVideo {

	constructor() {

		this.playerEl = null;
		this.containerEl = null;
		this.playButton = null;
		this.youtubeId = '';
		this.isPlaying = false;
		this.autoPlay = false;
		this.playerOptions = {};
		
	}

    handleStateChange(e) {
        if (e.data === YT.PlayerState.PLAYING) {
            this.isPlaying = true;
            this.containerEl.classList.remove(stateClasses.isLoading);
            this.containerEl.classList.add(stateClasses.isPlaying);
        }
        if (e.data === YT.PlayerState.ENDED) {
            this.isPlaying = false;
            this.containerEl.classList.remove(stateClasses.isPlaying);
            this.containerEl.classList.remove(stateClasses.isLoading);
        }
    }

    handleVideoReady() {
        this.containerEl.classList.remove(stateClasses.isLoading);
        this.playButton.removeAttribute('disabled');
    }

    handleClick() {
        if (!this.isPlaying) {
            this.containerEl.classList.add(stateClasses.isLoading);
            this.player.playVideo();
        }
    }

    setOptions() {
        this.playerOptions = {
            videoId: this.youtubeId,
            playerVars: {
                autoplay: this.autoPlay,
                rel: 0,
            },
            events: {
                onStateChange: this.handleStateChange.bind(this),
                onReady: this.handleVideoReady.bind(this),
            }
        };
    }

    addEventListeners() {
        this.containerEl.addEventListener('click', this.handleClick.bind(this));
    }

    init(el) {
        this.playerEl = el;
        this.containerEl = el.closest('.js-video-container');
        this.playButton = this.containerEl.querySelector('.js-play-button');
        this.youtubeId = el.getAttribute('data-video-id');
        this.autoPlay = el.getAttribute('data-autoplay');

        this.addEventListeners();
        this.setOptions();

        this.containerEl.classList.add(stateClasses.isLoading);

        this.player = new YT.Player(el, this.playerOptions);
    }
}